import { useIntl } from 'react-intl';
import { SerializedReel } from '../../types';
import { reelMessages, reelVoiceMessages } from './reelMessages';
import { releaseThemeMessages } from '../../themes/releaseThemeMessages';

import { reelFailShortMessages, reelReviewMessages } from './reelReviewMessages';

/**
 * The line under a history card (design c1): the reject reason, the short fail sentence, or the
 * theme and the voice. The card's accessible name carries it too.
 */
export function useReelHistoryWhy(reel: SerializedReel): string {
  const intl = useIntl();
  if (reel.status === 'rejected' && reel.rejectReason !== null && reel.rejectReason !== '') {
    return intl.formatMessage(reelReviewMessages.historyQuote, { reason: reel.rejectReason });
  }
  if (reel.status === 'failed') {
    return intl.formatMessage(reelFailShortMessages[reel.failReason ?? 'unknown']);
  }
  return intl.formatMessage(reelReviewMessages.historyWhy, {
    theme: intl.formatMessage(releaseThemeMessages[reel.themeId].name),
    voice: intl.formatMessage(reel.voiceId === null ? reelMessages.noVoiceover : reelVoiceMessages[reel.voiceId].label),
  });
}
